import styles from "./styles.module.scss";
import fogueteGif from "../../assets/foguete.gif";

export function AboutMe() {
  return (
    <section className={styles.AboutContainer} id="srollSuave">
      <h2 className="subtitle">
        quem sou eu <span>?</span>
      </h2>

      <div className={styles.AboutContent}>
        <div className={styles.gifRocket}>
          <span>
            <img src={fogueteGif} alt="" />
          </span>
        </div>
        <div>
          <h3>
            Olá, sente-se, vamos <br /> tomar um café? ☕
          </h3>
          <p>
            Me chamo welisson, tenho 22 anos, sou casado e não tenho filhos.
            <br />
            Eu sempre tive contato com computadores, aos 18 decidi me aprofundar
            mais no mundo da web, em 2020 eu recebi uma bolsa na Unespar -
            Parána em ciencias da computação, cursei por 1 ano, mas por motivos
            pessoais tive que trocar o curso pelo tecnologo em Analise e
            Desenvolvimento de sistemas na Unicesumar
          </p>
          <p>
            Eu tenho conhecimento em Html, Css, Javascript, ReactJs +
            Typescript. NextJs. Para Back eu entendo NodeJs + typescript,
            express, Mysql, PostgreSQL, Docker, Também tenho conhecimentos em
            Hardware, e conhecimentos basicos em Ux e Ui Design.
          </p>
        </div>
      </div>
    </section>
  );
}
